import { useEffect, useState } from "react";

const styles = {
  marginLeft: "5px",
  marginTop: "3px",
  height: "20px",
  width: "20px",
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: "red",
};
const yearLabel = [
  { index: 259, label: 5 },
  { index: 519, label: 10 },
  { index: 779, label: 15 },
  { index: 1039, label: 20 },
  { index: 1299, label: 25 },
  { index: 1819, label: 35 },
  { index: 2599, label: 50 },
  { index: 3379, label: 65 },
  { index: 4159, label: 80 },
];
function MomentoMori({
  boxColorOption = ["#4ea69d", "#b350aa", "#a5c45a", "#a1405d"],
}) {
  const [dateOfBirth, setDateOfBirth] = useState();
  const [boxColor, setBoxColor] = useState(boxColorOption?.[0]);
  const [week, setWeek] = useState([]);

  function weeksInLife(dateOfBirth, boxColor) {
    const today = new Date();
    const start = new Date(dateOfBirth);
    const end = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const weeks = [];
    for (let i = 0; i < 4160; i++) {
      let color;
      let date = start.toString();
      if (start <= end && start.getTime() <= end.getTime()) {
        color = boxColor;
      } else {
        color = "white";
      }
      weeks.push({
        date: date,
        color: color,
      });
      start.setDate(start.getDate() + 7);
    }
    return weeks;
  }
  useEffect(() => {
    setWeek(weeksInLife(dateOfBirth, boxColor));
  }, [dateOfBirth, boxColor]);
  return (
    <>
      <div className="container">
        <div style={{ marginLeft: "15px", marginTop: "30px", width: "80vw" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginRight: "20px",
            }}
          >
            <div>
              <span>Date of Birth:</span>{" "}
              <input
                type="date"
                onChange={(e) => setDateOfBirth(e.target.value)}
                style={{ borderRadius: "10px" }}
              />
            </div>
            <h3 style={{ textAlign: "left" }}>
              <i> Momento Mori Life Calender</i>
            </h3>
            <div style={{ display: "flex" }}>
              <span>Box Color:</span>{" "}
              {boxColorOption.map((color) => {
                return (
                  <div
                    style={{
                      ...styles,
                      backgroundColor: color,
                      border: boxColor !== color && "3px solid white",
                    }}
                    onClick={() => setBoxColor(color)}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="calender">
          {week.map((item, index) => {
            let sixMonth = index % 26 === 0;
            let rowSpace = (index + 1) % 520 === 0;
            console.log(item.date);
            return (
              <>
                <div
                  title={item.date !== "Invalid Date" && item.date.slice(4, 15)}
                  className="week-cell"
                  style={{
                    marginBottom: rowSpace && "10px",
                    marginLeft: sixMonth && "8px",
                    backgroundColor: item.color,
                  }}
                >
                  {index % 52 === 0 && (
                    <h6
                      style={{
                        fontSize: "10px",
                        marginLeft: "-60px",
                      }}
                    >
                      {item.date !== "Invalid Date" && item.date.slice(4, 15)}
                    </h6>
                  )}{" "}
                  {yearLabel.map((year) => {
                    if (year.index === index)
                      return (
                        <h6
                          style={{
                            fontSize: "14px",
                            marginLeft: "15px",
                            fontWeight: "bold",
                            marginTop: "-3px",
                          }}
                        >
                          {year.label}
                        </h6>
                      );
                  })}
                </div>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default MomentoMori;
